var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-item-group",
        {
          attrs: {
            "active-class": "primary"
          },
          model: {
            value: _vm.selection,
            callback: function callback($$v) {
              _vm.selection = $$v
            },
            expression: "selection"
          }
        },
        [
          _c(
            "v-row",
            _vm._l(_vm.wpItems, function(item, key) {
              return _c(
                "v-col",
                {
                  key: key,
                  attrs: {
                    cols: "12",
                    md: _vm.isResellerSubAccount ? 6 : 4
                  }
                },
                [
                  _c("v-item", {
                    attrs: {
                      value: item
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function fn(_ref) {
                            var active = _ref.active,
                              toggle = _ref.toggle
                            return [
                              _c(
                                "v-card",
                                {
                                  staticClass: "app-card d-flex align-center",
                                  attrs: {
                                    height: "100%"
                                  },
                                  on: {
                                    click: toggle
                                  }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass:
                                        "text-center pa-2 d-flex flex-column justify-space-between h-100",
                                      style: _vm.cardActiveStyle(active)
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "py-4"
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-auto",
                                                attrs: {
                                                  src: _vm.wizardIcon(item),
                                                  "max-height": "60",
                                                  contain: ""
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("h3", [
                                        _vm._v(" " + _vm._s(item.name) + " ")
                                      ]),
                                      _c(
                                        "h5",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !!item.subtitle,
                                              expression: "!!item.subtitle"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.subtitle) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mt-5 mb-2 mx-auto",
                                          attrs: {
                                            color: active ? "white" : "primary",
                                            secondary: "",
                                            width: "max-content"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                active ? "Selected" : "Select"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }